var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardSidebarIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11891",
    "data-name": "Group 11891",
    transform: "translate(-21 -27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic24-dashboard",
    d: "M10,14a1,1,0,0,1,1,1v6a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V15a1,1,0,0,1,1-1ZM21,9a1,1,0,0,1,1,1V21a1,1,0,0,1-1,1H14a1,1,0,0,1-1-1V10a1,1,0,0,1,1-1ZM10,2a1,1,0,0,1,1,1v8a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V3A1,1,0,0,1,3,2ZM21,2a1,1,0,0,1,1,1V6a1,1,0,0,1-1,1H14a1,1,0,0,1-1-1V3a1,1,0,0,1,1-1Z",
    transform: "translate(19 25)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardSidebarIcon);
export default __webpack_public_path__ + "static/media/dashboardSidebarIcon.00ea826b41748129e4dda8902eb403b4.svg";
export { ForwardRef as ReactComponent };